import React from "react"

const BaseCard = ({ className: styledClassName = "", children, ...props }) => {

    return <div className={`${styledClassName} base-card`} {...props}>
        {children}
    </div>
}

export default BaseCard